var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.882,
    height: 31,
    viewBox: "0 0 22.882 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#021d49;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M178.359,397.475a10.752,10.752,0,0,0-10.439,10.439c0,8.014,7.818,9.825,10.439,18.561,2.625-8.736,10.443-10.546,10.443-18.561A10.757,10.757,0,0,0,178.359,397.475Z",
    transform: "translate(-167.92 -397.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M176.874,402.071a3.955,3.955,0,1,0,3.955,3.955A3.954,3.954,0,0,0,176.874,402.071Z",
    transform: "translate(-166.329 -396.012)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8c437800052916f1e9c1c3626d8cce3e.svg";
export { ForwardRef as ReactComponent };